const TTL = 60 * 60 * 1000 // 1 hour — matches Figma CDN URL expiry

interface FigmaCacheEntry {
    imageUrl: string
    frameName: string | null
    fileName: string | null
    lastModified: string | null
    ts: number
}

const PREFIX = 'figma_cache_'

export function getFigmaCache(figmaUrl: string): Omit<FigmaCacheEntry, 'ts'> | null {
    try {
        const raw = localStorage.getItem(PREFIX + figmaUrl)
        if (!raw) return null
        const entry: FigmaCacheEntry = JSON.parse(raw)
        if (Date.now() - entry.ts > TTL) {
            localStorage.removeItem(PREFIX + figmaUrl)
            return null
        }
        const { ts: _, ...data } = entry
        return data
    } catch {
        return null
    }
}

export function setFigmaCache(figmaUrl: string, data: Omit<FigmaCacheEntry, 'ts'>): void {
    try {
        localStorage.setItem(PREFIX + figmaUrl, JSON.stringify({ ...data, ts: Date.now() }))
    } catch {
        // localStorage full or unavailable — silently skip
    }
}
